import React from "react";
import PropTypes from "prop-types";
import { prependRoot } from "../../util/prependRoot.js";
import { getApiRoot } from "../../store/configureStore.js";
import classnames from "classnames";
import Dropzone from "react-dropzone";
import { showToastrError } from "../../util/toastr.js";
import Tooltip from "../common/Tooltip";
import * as types from "../../constants/ComponentConstants";
import ValidationMessage from "../common/ValidationMessage";
import Row from "../common/Row";

const routePrefix = "/document/";

const DownloadUploadFiles = (props) => {
	const hasFiles = !!props.files;
	const hasValidationMessage = !!props.validationMessage;
	const validationMessageType = props.validationMessageType;
	const validation = props.validationMessage ? <ValidationMessage validationMessage={props.validationMessage} type={props.validationMessageType} /> : null;
	const isUpload = !!props.onDrop;
	const canDelete = !!props.onDelete;
	const infrastructuur = !!props.infrastructuurId;
	const fileSessionStarted = !!props.fileSessionStarted;
	const tooltiptype = props.tooltipType || types.TOOLTIP_INFO;
	const defaultText = props.defaultText ? props.defaultText : "Geen documenten geüpload door Sport Vlaanderen";
	let info = props.tooltip ? <Tooltip text={props.tooltip} tooltipType={tooltiptype} iconColor={props.tooltipIconColor} windowWidth={props.tooltipWindowWidth} /> : null;

	const serviceUrl = prependRoot(routePrefix, getApiRoot());
	const center = (<div className="o-col-1">&nbsp;</div>);
	const sizeClassName = props.center ? "o-col-10" : (props.size ? "o-col-" + props.size : "o-col-12");

	function handleDelete(event) {
		props.onDelete(event.target.getAttribute('value'));
	}

	function onRejected(event) {
		showToastrError("Het is enkel mogelijk om bestanden van het type " + props.fileTypes.extensions + " op te laden.");
	}

	let body;
	if (isUpload) {
		let dropzoneProps = {
			className: "c-dropzone",
			accept: props.fileTypes ? props.fileTypes.mimeTypes : "",
			onDrop: props.onDrop,
			onDropRejected: onRejected,
			activeClassName: "c-dropzone--accepted",
			rejectClassName: "c-dropzone--rejected"
		};

		let filetypeText = "";
		if (props.fileTypes) {
			const fileTypes = props.fileTypes.extensions.replace(/,(?=[^,]*$)/, ' en');
			filetypeText = "Toegelaten formaten " + fileTypes + ".";
		}

		if (props.tooltip)
			info = <Tooltip text={props.tooltip + "\n" + filetypeText} tooltipType={tooltiptype} iconColor={props.tooltipIconColor} windowWidth={props.tooltipWindowWidth} />;
		else {
			if (filetypeText)
				info = <Tooltip text={filetypeText} tooltipType={tooltiptype} iconColor={types.COLOR_WHITE} windowWidth={25} />;
		}


		body = (
			<Dropzone {...dropzoneProps}>
				<div className={"uploadzone"}>
					Sleep hier jouw document(en) of klik hier om te bladeren
				</div>
			</Dropzone>
		);
	}
	else {
		body = (!hasFiles || props.files.length == 0) ? defaultText : null;
	}
	if (isUpload && props.disabled) {
		body = null;
	}

	const fileList = hasFiles ? (
		<ul className="filelist">
			{
				props.files.map((file, i) => {
					let path;
					const component = props.component.replace(/"/g, '');

					if (isUpload && infrastructuur) {
						path = serviceUrl + props.dossierId + "/infrastructuur/" + props.infrastructuurId + "/" + props.tab + "/" + component + "/" + file.name + "/" + fileSessionStarted;
					} else if (((isUpload || props.downloadOnly) && !props.isPdf && !props.isPdfVoortgangsrapport) || props.isOndertekendePdfSubsidie) {
						path = serviceUrl + props.dossierId + "/" + props.tab + "/" + component + "/" + file.name + "/" + fileSessionStarted;
					} else if (props.isPdf) {
						if (props.tab)
							path = serviceUrl + props.dossierId + "/pdf/" + props.tab;
						else
							path = serviceUrl + props.dossierId + "/pdf";
					} else {
						path = serviceUrl + "sjabloon/" + props.tab + "/" + component + "/" + file.name;
					}

					const delIcon = canDelete && !props.disabled ? <i className="fa fa-times deletebutton" value={file.name} onClick={handleDelete}/> : null;

					return (
						<li key={file.name}>
							{delIcon}
							<a href={path}>
								{file.name}
							</a>
						</li>);
				})
			}
		</ul>) : null;

	let cFicheClassNames = {
		"c-fiche": true,
		[props.color]: true,
		"c-fiche--downloaduploadfiles": true,
		"disabled": props.disabled,
		"error": hasValidationMessage,
		"warning": hasValidationMessage && validationMessageType === types.ValidationMessageTypes.WARNING
	};

	const component = (<div className={classnames(sizeClassName)}>
		<div className={classnames("c-fiche-wrap", "u-clear")}>
			<div className={classnames(cFicheClassNames)}>
				<header className="c-fiche__header">
					<h1 className="title">{props.title + (props.optional ? " (Optioneel)" : "")}{info}</h1>
				</header>
				<div className="c-fiche__body">
					{body}
					{fileList}
				</div>
			</div>
		</div>
		{validation}
	</div>);

	return (props.center ? <Row>{center}{component}</Row> : component);
};

DownloadUploadFiles.propTypes = {
	title: PropTypes.string.isRequired,
	color: PropTypes.string.isRequired,
	tab: PropTypes.string.isRequired,
	component: PropTypes.string.isRequired,
	infrastructuurId: PropTypes.string,
	disabled: PropTypes.bool,
	dossierId: PropTypes.string,
	validationMessage: PropTypes.string,
	validationMessageType: PropTypes.string,
	size: PropTypes.number,
	center: PropTypes.bool,
	onDrop: PropTypes.func,
	onDelete: PropTypes.func,
	files: PropTypes.array,
	fileTypes: PropTypes.object,
	optional: PropTypes.bool,
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	tooltipIconColor: PropTypes.string,
	tooltipWindowWidth: PropTypes.number,
	fileSessionStarted: PropTypes.bool,
	downloadOnly: PropTypes.bool,
	isPdf: PropTypes.bool,
	isPdfVoortgangsrapport: PropTypes.bool,
	voortgangsrapportId: PropTypes.string,
	defaultText: PropTypes.string,
	isOndertekendePdfSubsidie: PropTypes.bool
};

DownloadUploadFiles.defaultProps = {
	isPdf: false
};

export default DownloadUploadFiles;
